import { PlayerLayout } from '@core/player/types';
/**
 * Selector for VideoPlayer actions
 */
export function videoPlayerActionsSelector(state) {
    return state.actions;
}
/**
 * Selector for VideoPlayer isUserPaused
 */
export function videoPlayerIsUserPausedSelector(state) {
    return state.isUserPaused;
}
/**
 * Selector for VideoPlayer isUserMuted
 */
export function videoPlayerIsUserMutedSelector(state) {
    return state.isUserMuted;
}
/**
 * Selector for VideoPlayer isVisible
 */
export function videoPlayerIsVisibleSelector(state) {
    return state.isVisible;
}
/**
 * Get current layout of the video player.
 * Fullscreen, minimized or default (inline)
 */
export function videoPlayerLayoutSelector(state) {
    return state.layout;
}
/**
 * Selector for VideoPlayer openReason
 */
export function videoPlayerOpenReasonSelector(state) {
    return state.openReason;
}
/**
 * Provide currently available width given the current
 * layout (minimized, fullscreen or default - inline).
 */
export function videoPlayerAvailableWidthSelector(state) {
    return state.layoutSize.width;
}
/**
 * Provide currently available height given the current
 * layout (minimized, fullscreen or default - inline).
 */
export function videoPlayerAvailableHeightSelector(state) {
    return state.layoutSize.height;
}
/**
 * Convenience selector to check if the player is in minimized layout.
 * @param state
 * @returns
 */
export function videoPlayerIsMinimizedSelector(state) {
    return state.layout === PlayerLayout.MINIMIZED;
}
/**
 * Convenience selector to check if the player is in fullscreen layout.
 * @param state
 * @returns
 */
export function videoPlayerIsFullscreenSelector(state) {
    return state.layout === PlayerLayout.FULLSCREEN;
}
/**
 * Get ui zoom level
 * @param state
 * @returns
 */
export function videoPlayerUiZoomSelector(state) {
    return state.uiZoom;
}
/**
 * Return `isDesktop` flag from the state. This flag is set to true if
 * available width and height are greater than some amount. See `setLayoutSize`
 * action. Should be DEPRECATED in favor of usePlayerLayout hook (ZE-400).
 * @param state
 * @returns
 * @deprecated
 */
export function videoPlayerIsDesktopSelector(state) {
    return state.isDesktop;
}
/**
 * Selector for VideoPlayer navigationLocked flag
 */
export function videoPlayerNavigationLockedSelector(state) {
    return state.navigationLocked;
}
/**
 * Selector for VideoPlayer `isIMAActive` flag
 */
export function videoPlayerIsIMAActiveSelector(state) {
    return state.isIMAActive;
}
/**
 * Selector for VideoPlayer videosWatchedCount for interstitial ads
 */
export function videoPlayerVideosWatchedCountSelector(state) {
    return state.videosWatchedCount;
}
/**
 * @returns player integration callbacks
 */
export function videoPlayerInterruptionEventCallbackSelector(event) {
    return function (state) {
        return state.interruptionCallbacks?.[event] || (() => Promise.resolve());
    };
}
/**
 * @returns player Initialized
 */
export function videoPlayerScrolledToInitialVideoSelector(state) {
    return state.scrolledToInitialVideo;
}
